module.exports = __webpack_public_path__ + "static/media/pemira-logo.d5df0755.jpg";